//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';
import constant from '~/const';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      filters: {
        searchString: '',
        nfaServiceTypeList: [],
        sectionList: [],
        dateCreatedFrom: '',
        dateCreatedTo: '',
        enabled: undefined,
      },
      constant,
    };
  },

  computed: {
    ...mapState('userSecurityHistoryNfa', ['filterLists']),
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  created() {
    this.setFilters({});
  },

  methods: {
    ...mapActions('userSecurityHistoryNfa', ['setFilters']),
  },
};
